import PropTypes from 'prop-types'
import React from 'react'
import { EXPAND_BUTTON_TYPES } from 'constants/button'
import ExpandButton from 'components/common/button/expand'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import { withI18next } from 'lib/i18n/withI18next'

const goBackToTop = (e) => {
  e.preventDefault()
  window.scroll({ top: 0, behavior: 'smooth' })
  e.stopPropagation()
}
const BackToTopCTA = ({ showBackToTop, t }) => {
  if (!showBackToTop) return null

  return (
    <ExpandButton
      className="back-to-top"
      type={EXPAND_BUTTON_TYPES.floatingText}
      onClick={goBackToTop}
    >
      <Icon src={ICONS.dropupSmall} size={ICON_SIZE.small} />
      {t('Back to top')}
    </ExpandButton>
  )
}

BackToTopCTA.propTypes = {
  showBackToTop: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(BackToTopCTA)
